import React from 'react'
// ##
import LoginBox from '../../modules/Auth/components/LoginBox'

export default function LoginPage() {
  return <LoginBox />
}
